// extracted by mini-css-extract-plugin
export default {"buttons":"tutorials-edit_buttons__QrlL+","date":"tutorials-edit_date__yJ7tN","mediasContainer":"tutorials-edit_mediasContainer__o1V3l"};